<template>
    <nav
        :class="{
            '_direction_column': column,
            '_border': border
        }"
        class="emd-nav-list"
    >
        <ul>
            <slot />
        </ul>
    </nav>
</template>

<script>
export default {
  name: 'emdNavList',
  props: {
    column: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    }
  }
}
</script>
